import store from '..'
import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
    airport: [],
    setting: {
      use: false,
      search: 200,
      visible: [],
      display: []
    }
  },
  mutations: {
    setUse: function (state, data) {
      state.setting.use = data
    },
    setVisible: function (state, data) {
      const isVisible = data.visible
      if (isVisible) {
        state.setting.visible.push(data.airportName)
      } else {
        state.setting.visible = state.setting.visible.filter(x => x !== data.airportName)
      }
    },
    setSearchDistance: function (state, km) {
      state.setting.search = km
    }
  },
  actions: {
    setAirportDisplay ({ state }) {
      const list = state.airport.map(x => x.airportName)
      const display = state.setting.visible.filter(x => list.includes(x))
      state.setting.display = state.airport.filter(x => display.includes(x.airportName))
      return display
    },
    async getAirportSetting ({ state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'flightinfo/airport.json'
        })
        state.setting = Object.assign(state.setting, res.data.message)
        return res.data.message
      } catch (ex) {
        return false
      }
    },
    async setAirportSetting ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.SET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'flightinfo/airport.json',
          data: JSON.stringify(data)
        })
        return res.data.message
      } catch (ex) {
        return false
      }
    },
    setAirportSettingData ({ state, dispatch }) {
      return dispatch('getAirportSetting').then(res => {
        if (!res) {
          const visibleAirport = state.airport.map(x => x.airportName)
          const visible = !res ? visibleAirport : res.visible
          const display = !res ? visibleAirport : res.display
          const data = {
            visible: visible,
            display: display,
            search: 200
          }
          dispatch('setAirportSetting', data).then(() => {
            state.setting = data
          })
          return true
        } else {
          return state.setting
        }
      }).catch((ex) => {
        console.error('error:', ex)
        return false
      })
    },
    async getAirport ({ state }, km) {
      const distance = km || 200
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_FLIGHT_INFO_AIRPORT,
          id: store.state.authentication.requestId,
          distanceKM: distance
        })
        state.airport = res.data.message
        return res.data.message
      } catch (ex) {
        return false
      }
    },
    setAirport ({ state }, data) {
    }
  },
  getters: {
    getAirport: (state) => state.airport
  }
}
